// src/sectors/pilates/sessions/components/calendar/MobileDayList/mobileDayList.atoms.jsx
import React from 'react';
import { alpha } from '@mui/material/styles';
import Icon from '@mui/material/Icon';

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

/* ---------------- helpers ---------------- */
export function toneColor(theme, tone) {
  if (tone === 'danger' || tone === 'red') return theme.palette.error.main;
  if (tone === 'success' || tone === 'mint' || tone === 'green') return theme.palette.success.main;
  return theme.palette.info.main;
}

/* ---------------- SoftShell (FORWARD REF ✅) ---------------- */
export const SoftShell = React.forwardRef(function SoftShell({ children, tone = 'blue', sx }, ref) {
  return (
    <MDBox
      ref={ref}
      sx={(t) => {
        const isDark = t.palette.mode === 'dark';
        const c = toneColor(t, tone);

        const baseBorder = `1px solid ${alpha(t.palette.text.primary, isDark ? 0.14 : 0.1)}`;

        return {
          borderRadius: '18px',
          border: baseBorder,
          overflow: 'hidden',
          background: isDark ? 'rgba(255,255,255,0.04)' : 'rgba(255,255,255,0.92)',
          boxShadow: `0 16px 36px ${alpha(c, isDark ? 0.1 : 0.08)}`,
          ...(typeof sx === 'function' ? sx(t) : sx),
        };
      }}
    >
      {children}
    </MDBox>
  );
});

/* ---------------- MiniTag (optional) ---------------- */
export function MiniTag({ icon, label, tone = 'blue' }) {
  return (
    <MDBox
      sx={(t) => {
        const isDark = t.palette.mode === 'dark';
        const c = toneColor(t, tone);
        const border = `1px solid ${alpha(t.palette.text.primary, isDark ? 0.14 : 0.1)}`;

        return {
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.55,
          px: 0.9,
          py: 0.5,
          borderRadius: '999px',
          border,
          background: alpha(c, isDark ? 0.14 : 0.1),
          fontWeight: 900,
        };
      }}
    >
      <Icon sx={(t) => ({ fontSize: 18, color: toneColor(t, tone) })}>{icon}</Icon>
      <MDTypography variant="caption" sx={{ fontWeight: 900, lineHeight: 1 }}>
        {label}
      </MDTypography>
    </MDBox>
  );
}
